var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "template" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择库存备件",
            top: "5vh",
            visible: _vm.dialogVisible,
            width: "70%",
            "append-to-body": "",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-top" },
            [
              _c("el-input", {
                staticStyle: { width: "300px", "margin-left": "10px" },
                attrs: { clearable: "", placeholder: "请输入备件编号/名称" },
                model: {
                  value: _vm.searchData.Keyword,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchData, "Keyword", $$v)
                  },
                  expression: "searchData.Keyword",
                },
              }),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSearch },
                },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "dialog-center",
            },
            [
              _c(
                "el-table",
                {
                  ref: "dialogTable",
                  class:
                    _vm.type == "checkBox" ? "checkBoxTable" : "radioTable",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tableData, height: "calc(100% - 40px)" },
                  on: {
                    "selection-change": _vm.handleSelectionChange,
                    select: _vm.handleSelect,
                    "row-click": _vm.handleRowClick,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "", width: "50", type: "selection" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "序号", width: "50", type: "index" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "备件编号",
                      align: "center",
                      prop: "Code",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "备件名称",
                      align: "center",
                      prop: "Name",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "备件类型",
                      align: "center",
                      prop: "MaterialTypeName",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "备件规格",
                      align: "center",
                      prop: "Spec",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "单位",
                      align: "center",
                      prop: "storageName",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "专属设备",
                      align: "center",
                      prop: "device_name",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "库存数量",
                      align: "right",
                      prop: "Nums_N",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "货位",
                      align: "center",
                      prop: "LocalName",
                      sortable: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    height: "40px",
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "right",
                  },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.pagination.PageIndex,
                      "page-sizes": _vm.pagination.PageSizes,
                      "page-size": _vm.pagination.PageRows,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.pagination.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }